import { createFileRoute } from '@tanstack/react-router';

import { F29Page } from '@/features/f29/components/f29-page';
import { f29SearchSchema } from '@/features/f29/constants/search-params';

export const Route = createFileRoute('/_app/f29/')({
  component: F29Page,
  validateSearch: (raw) => f29SearchSchema.parse(raw),
});
